module.exports = __webpack_public_path__ + "static/media/tick.88d50b2a.svg";